import { getCalcRem } from "src/assets/jss/material-kit-react.js"

import defaultComponentStyles from "src/assets/jss/material-kit-react/defaultComponentStyles"

const propertyDetailStyles = theme => ({
  ...defaultComponentStyles,
  propertyDetailRoot: {
    [theme.breakpoints.up("md")]: {
      marginLeft: theme.spacing(4),
      marginRight: theme.spacing(4),
    },
    "& *": {
      textTransform: "none",
      lineHeight: getCalcRem(22),
      [theme.breakpoints.up("md")]: {
        lineHeight: getCalcRem(32),
      },
    },
    "& .propertyDetailInfo-root": {
      padding: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(4),
      },
      [theme.breakpoints.up("md")]: {
        paddingLeft: 0,
        paddingRight: 0,
      },
      "& h4": {
        textAlign: "center",
        justifyContent: "center",
        display: "flex",
        "& .propertyDetailInfo_city": {
          whiteSpace: "nowrap",
        },
      },

      "& .MuiList-root": {
        listStyle: "none",
        flexDirection: "column",
        width: "50%",
        margin: "0 auto",
        [theme.breakpoints.up("sm")]: {
          width: "30%",
        },
        [theme.breakpoints.up("md")]: {
          flexDirection: "unset",
          flexWrap: "wrap",
          width: "100%",
        },
        "& .MuiListItem-root": {
          display: "flex",
          justifyContent: "space-between",
          marginBottom: theme.spacing(1),
          [theme.breakpoints.up("md")]: {
            justifyContent: "unset",
          },
          /*
          "&:last-of-type": {
            "& span:first-of-type": {
              [theme.breakpoints.up("md")]: {
                width: "20%",
              },
            },
          },*/
          "& span:first-of-type": {
            display: "inline-block",
            [theme.breakpoints.up("md")]: {
              width: "40%",
            },
          },
        },
      },
      "& .quote-root": {
        display: "flex",
        flexDirection: "column",
        marginBottom: theme.spacing(4),
        "& .quote-text": {
          fontStyle: "italic",
        },
        "& .quote-author": {
          /** alignSelf: "flex-end", */
          marginLeft: theme.spacing(2),
        },
        [theme.breakpoints.up("md")]: {
          justifyContent: "center",
          /*          flexDirection: "row", */
        },
      },
    },
  },
})

export default propertyDetailStyles
